import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ dataComponents: { savedViews } }: ComposedTheme) => ({
  activeView: {
    background: 'none',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    '& svg': {
      fill: savedViews.text.color,
    },
  },
  groupSpacing: {
    marginTop: 16,
  },
  groupName: {
    fontFamily: savedViews.group.text.fontFamily,
    fontSize: savedViews.group.text.fontSize,
    fontWeight: savedViews.group.text.fontWeight,
    textTransform: savedViews.group.text.textTransform,
    color: savedViews.group.text.color,
    margin: [4, 16],
    height: 20,
    paddingBottom: 4,
    borderBottom: `1px solid ${savedViews.group.borderColor}`,
    lineHeight: 1,
  },
  groupEmpty: {
    fontFamily: savedViews.group.empty.text.fontFamily,
    fontSize: savedViews.group.empty.text.fontSize,
    fontWeight: savedViews.group.empty.text.fontWeight,
    padding: [0, 16],
    height: 32,
    color: savedViews.group.empty.text.color,
  },
  infoIcon: {
    marginRight: 8,
    '& svg': {
      fill: savedViews.divergedIconColor,
    },
  },
  activeViewName: {
    fontFamily: savedViews.text.font.fontFamily,
    fontSize: savedViews.text.font.fontSize,
    fontWeight: savedViews.text.font.fontWeight,
    textTransform: savedViews.text.font.textTransform,
    color: savedViews.text.color,
    marginRight: 8,
    display: 'flex',
    alignItems: 'center',
  },
  dropdownList: {
    margin: 0,
    padding: [8, 0],
    listStyle: 'none',
  },
  popover: {
    padding: 0,
  },
  wrap: {
    display: 'flex',
    alignItems: 'center',
  },
});

export default createUseStyles(styles);
